import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";

import { useSchool, useSdk } from "./hooks";
import { useUser } from "./hooks/useUser";

const GamificationBalanceContext = createContext(0);

export const GamificationBalanceProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  //   const userStore = useInstance(UserStore);
  const [gamificationBalance, setGamificationBalance] = useState(0);
  const school = useSchool();
  const { user, isAuthorized } = useUser();
  //   const hub = useInstance(HubClient);
  const sdk = useSdk();

  useEffect(() => {
    if (!school.gamification || !user || !isAuthorized) return;
    (async () => {
      const res = await sdk.api.gamification.fetchBalance();
      setGamificationBalance(res?.body ?? 0);
    })();

    const dispose = sdk.hub.gamification.balance.subscribe((score) =>
      setGamificationBalance(score),
    );

    return () => dispose();
  }, [
    isAuthorized,
    school.gamification,
    sdk.api.gamification,
    sdk.hub.gamification.balance,
    user,
  ]);

  return (
    <GamificationBalanceContext.Provider value={gamificationBalance}>
      {children}
    </GamificationBalanceContext.Provider>
  );
};

export const useGamificationBalance = () =>
  useContext(GamificationBalanceContext);
